import React, { useState } from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Button } from 'js/design_system/Button';
import { FollowableUser, News, NewsStory } from 'js/social/shared/types';
import ImpressionWatcher from 'js/utils/impressions/ImpressionWatcher';
import { MultiPaperModal } from './MultiPaperModal';
import { ImpressionPropsGenerator } from '../ImpressionHelper';
import _Container from "MultiPaperNewsStory-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperNewsStory.tsx?styleId=Container";
import _ContentAndButtonsContainer from "MultiPaperNewsStory-ContentAndButtonsContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperNewsStory.tsx?styleId=ContentAndButtonsContainer";
import _ContentContainer from "MultiPaperNewsStory-ContentContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperNewsStory.tsx?styleId=ContentContainer";
import _Heading from "MultiPaperNewsStory-Heading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperNewsStory.tsx?styleId=Heading";
import _NewsBody from "MultiPaperNewsStory-NewsBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperNewsStory.tsx?styleId=NewsBody";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const ContentAndButtonsContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ContentAndButtonsContainer",
  styles: _ContentAndButtonsContainer
});

const ContentContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ContentContainer",
  styles: _ContentContainer
});

const Heading = /*#__PURE__*/styled(Body, null, {
  displayName: "Heading",
  styles: _Heading
});

const NewsBody = /*#__PURE__*/styled(Body, null, {
  displayName: "NewsBody",
  styles: _NewsBody
});

type Props = {
  newsStory: NewsStory;
  impressionPropsGen: ImpressionPropsGenerator;
  props: ModalProps;
};

type ModalProps = News & {
  getUserData: (id: number) => FollowableUser;
  index: number;
};

const MultiPaperStoryContainer: React.FunctionComponent<Props> = ({
  newsStory,
  impressionPropsGen,
  props,
}) => {
  const { heading, body, papers } = newsStory;

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const modal = (
    <MultiPaperModal
      open={showModal}
      onClose={handleCloseModal}
      heading={heading}
      body={body}
      papers={papers ?? []}
      impressionPropsGen={impressionPropsGen}
      props={props}
    />
  );

  const content = (
    <>
      <ContentAndButtonsContainer>
        <ContentContainer>
          <ImpressionWatcher {...impressionPropsGen()()('story-body')}>
            {heading && <Heading size="lg">{heading}</Heading>}
            {body && <NewsBody size="lg">{body}</NewsBody>}
          </ImpressionWatcher>
        </ContentContainer>
      </ContentAndButtonsContainer>
    </>
  );

  const paperSetInteractions = (
    <>
      <ImpressionWatcher {...impressionPropsGen()()('view-studies-button')}>
        <Button size="xs" icon="description" onClick={handleOpenModal}>
          View Studies
        </Button>
      </ImpressionWatcher>
    </>
  );

  return (
    <Container>
      {modal}
      {content}
      {paperSetInteractions}
    </Container>
  );
};

export default MultiPaperStoryContainer;
